import { motion } from "framer-motion";

const CHAPTERS = [
  {
    no: "01",
    title: "Visi & Presisi Struktural",
    body: "Setiap bangunan dimulai dari hitungan, bukan asumsi. Tim insinyur struktur kami memastikan fondasi, kolom, dan balok melampaui standar SNI — karena kemewahan sejati adalah rasa aman selama puluhan tahun.",
  },
  {
    no: "02",
    title: "Material Otentik",
    body: "Marmer Carrara, jati Perhutani grade-A, beton ekspos arsitektural. Kami memilih material langsung dari sumbernya dan menolak kompromi pada apa pun yang akan Anda sentuh setiap hari.",
  },
  {
    no: "03",
    title: "Manajemen Tanpa Retak",
    body: "Jadwal mingguan terukur, foto progres via drone, dan satu manajer proyek khusus untuk Anda. Transparansi penuh dari pondasi hingga serah terima kunci.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-mono-arch text-[11px] tracking-[0.35em] uppercase text-brass mb-5"
      >
        Manifesto Kami
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        className="font-serif-lux font-light text-3xl sm:text-4xl lg:text-5xl text-bone tracking-tight max-w-2xl leading-[1.12]"
      >
        Tiga bab yang menjamin <span className="italic brass-text-gradient">mahakarya</span> Anda berdiri abadi.
      </motion.h2>

      <div className="mt-16 lg:mt-20 grid md:grid-cols-3 gap-10 lg:gap-0">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.no}
            data-testid={`manifesto-chapter-${c.no}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.15 }}
            className={`lg:px-10 ${i > 0 ? "lg:border-l lg:border-[rgba(197,160,89,0.2)]" : "lg:pl-0"}`}
          >
            <p className="font-serif-lux text-6xl lg:text-7xl brass-text-gradient leading-none">{c.no}</p>
            <h3 className="font-serif-lux text-2xl text-bone mt-6">{c.title}</h3>
            <p className="text-sm text-ash font-light leading-relaxed mt-4">{c.body}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
